// Catálogo único de categorías (líneas) del Scorecard por asesor.
//
// La `clave` es el sufijo con el que el endpoint
// CargaScorecardporVendedorDash/MostrarScorecardVendedorporParametrosTablaAsesor
// nombra sus propiedades: objetivo_<clave>, real_<clave> y comp_<clave>.
// Ejemplo: clave "Refacciones" -> objetivo_Refacciones, real_Refacciones,
// comp_Refacciones.
//
// Para agregar una línea nueva al tablero basta con agregar un renglón aquí:
// el filtro, los totales por Grupo/ADR/Sucursal y las filas de asesor se
// generan a partir de este arreglo.
export const CategoriasScorecardArray = [
    { clave: "Tractores", etiqueta: "Tractores", icono: "🚜" },
    { clave: "Implementos", etiqueta: "Implementos", icono: "🛠️" },
    { clave: "Jardineros", etiqueta: "Jardineros", icono: "🌱" },
    { clave: "Autoguiados", etiqueta: "Autoguiados", icono: "🧭" },
    { clave: "Drones", etiqueta: "Drones", icono: "🚁" },
    { clave: "PA", etiqueta: "Producto Aliado", icono: "🤝" },
    { clave: "TracUsa", etiqueta: "Tractores Seminuevos", icono: "♻️" },
    { clave: "TriUsa", etiqueta: "Trilladoras Seminuevas", icono: "🔄" },
    { clave: "Garantia", etiqueta: "Garantía Extendida", icono: "🛡️" },
    { clave: "Poliza", etiqueta: "Poliza Mantenimiento", icono: "📄" },
    { clave: "Refacciones", etiqueta: "Refacciones", icono: "🔧" },
    // { clave: "Visitas", etiqueta: "Visitas", icono: "📍" },
];

// Claves usadas para acumular objetivo/real/comparativo por ADR y por sucursal.
export const ClavesCategoriasScorecard = CategoriasScorecardArray.map(
    (categoria) => categoria.clave
);

// Mapa clave -> etiqueta, para el encabezado de la tabla.
export const EtiquetasCategoriasScorecard = CategoriasScorecardArray.reduce(
    (acumulado, categoria) => ({
        ...acumulado,
        [categoria.clave]: categoria.etiqueta,
    }),
    {}
);

// Opciones con el formato que espera FilterPanel.
export const OpcionesCategoriasScorecard = CategoriasScorecardArray.map(
    (categoria) => ({
        value: categoria.clave,
        label: categoria.etiqueta,
        icon: categoria.icono,
    })
);
